fragment ProductVariationFragment on ProductVariation {
    id

    attributeValues {
        ...ProductVariationAttributeValueFragment
    }

    media {
        ...ProductVariationMediaFragment
    }

    created_at
    updated_at

    product_id
    color_id

    color {
        id
        code
        name
        brand
        hex_codes
        color_group_id
    }

    code_of_type

    material

    capacity

    height
    length
    width
    net_weight

    size_code
    size_name

    unit_prefix
    unit_name

    packed_in_box
    packed_in_polybag

    qty_of_battery
    type_of_battery

    flash_type
    flash_version
    flash_id

    ean_code
    statistic_code

    merge_class
    stock_product
    adornments
    decorations

    minimum_order_qty
    delivery_time
    country_of_origin

    qty_in_inner_carton
    qty_per_outer_carton
    qty_per_pallet

    carton_height
    carton_length
    carton_width
    carton_gross_weight

    group_code
    video_url

    prices_gross
    prices_net
    original_prices

    supplier_id
}